export const fr = {
    // Traductions en italien :
    required: '* Champ obligatoire',
    validation: {
        required: controlName => `Veuillez saisir ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        minmaxNotLessThen: (controlName, min) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} ne peut pas être inférieur à ${min}`,
        minmaxNotGreaterThen: (controlName, max) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} ne peut pas être supérieur à ${max}`,
    },
    switch: {
        yes: 'Oui',
        no: 'Non',
    },
    dateRange: {
        arrival: 'Arrivée',
        departure: 'Départ',
    },
    travelData: {
        title: 'Saisissez les informations de votre séjour et recevez des offres personnalisées par e-mail, directement des établissements.',
        range: 'date d\'arrivée et de départ',
        hasPets: 'Animaux',
        petsMessage: 'description des animaux',
        petsMessagePlaceholder: "ex. 1 grand chien (environ 10 kg), 2 chats...",
        boards: 'Pension',
        rooms: {
            validation: {
                roomsMissing: 'Veuillez entrer au moins 1 chambre',
                adultsMissing: 'Veuillez indiquer le nombre d\'adultes',
                roomsWithoutAdults: 'Veuillez entrer au moins 1 adulte par chambre',
                childAgeMissing: 'Veuillez indiquer l\'âge des enfants',
            },
            adults: 'Adultes',
            children: 'Enfants',
            rooms: 'Chambres',
            age: 'Âge',
            room: 'Chambre/appartement',
            roomInfo: 'Informations relatives à une chambre, un appartement, un emplacement, etc.',
            removeRoom: 'Supprimer la chambre/appartement',
            addRoom: 'Ajouter une chambre/appartement',
            childrenAges: 'Âges des enfants',
            years: age => `${age} ${age == 1 ? 'an' : 'ans'}`,
            done: 'Terminé',
        },
        submit: 'Continuer',
    },
    filter: {
        title: 'Choisissez le type d\'hébergement et la région de votre choix et découvrez les établissements qui correspondent à vos critères !',
        accotypesValidatorText: controlName => `Choisissez ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        areaValidatorText: controlName => `Choisissez ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        maxCountValidatorText: (controlName, max) => `Vous pouvez sélectionner un maximum de ${max} logements.\nUtilisez d'autres filtres.`,
        accotypesAndBoards: 'Type d\'hébergement & pension',
        boards: 'Pension',
        accotypes: 'Type d\'hébergement',
        areas: 'Régions & localités',
        resorts: 'Localités',
        regions: 'Régions',
        selectAllRegions: 'Sélectionnez toutes les régions du Haut-Adige',
        searchAreas: 'Recherche de régions et de localités...',
        themesAmeneties: 'Équipements / Type de vacances',
        ameneties: 'Équipements',
        themes: 'Type de vacances',
        overlay: {
            accosText: count => `<b>${count}</b> ${count == 1 ? "hébergement" : "hébergements"} sélectionné(s)`,
            done: 'Terminé',
        },
        back: 'Retour',
        submitContinueWith: 'Continuer avec',
        submitAccosText: count => `${count} ${count == 1 ? "hébergement" : "hébergements"}`,
    },
    accos: {
        title: 'Aperçu des hébergements',
        subtitle: (selected, count) => `Envoyez une demande à ${selected} ${selected == 1 ? "établissement" : "établissements"} ou choisissez un établissement spécifique`,
        back: 'Retour',
        submitContinueWith: 'Continuer avec',
        submitAccosText: count => `${count} ${count == 1 ? "hébergement" : "hébergements"}`,
    },
    personalData: {
        accosCount: count => `<b>${count}</b> ${count == 1 ? "hébergement" : "hébergements"}`,
        adults: count => `<b>${count}</b> ${count == 1 ? 'Adulte' : 'Adultes'}`,
        children: count => `<b>${count}</b> ${count == 1 ? 'Enfant' : 'Enfants'}`,
        rooms: count => `<b>${count}</b> ${count == 1 ? 'Chambre' : 'Chambre'}`,
        pets: 'Animaux',
        accotypes: count => `${count == 1 ? `Type d'hébergement:` : `Types d'hébergement:`}`,
        areas: count => `${count == 1 ? 'Région/localité:' : 'Régions/localités:'}`,

        title: 'Saisissez vos données pour recevoir des offres personnalisées directement des établissements !',
        email: 'E-mail',
        salutation: 'Civilité',
        salutationOptions: {
            herr: 'Monsieur',
            frau: 'Madame',
            familie: 'Famille',
            firma: 'Société',
        },
        firstname: 'Prénom',
        lastname: 'Nom',
        phone: 'Téléphone',
        message: 'Remarques & questions',
        privacy: privacyUrl => `Oui, j'accepte le <a href="${privacyUrl}" target="_blank">traitement de mes données personnelles</a>.`,
        privacyRequired: 'Accepter le traitement des données',
        newsletter: 'Oui, je souhaite recevoir la newsletter de alto-adige.com',
        newsletterNote: 'Notre newsletter gratuite est envoyée régulièrement une fois par mois, avec les meilleures offres de vacances en Haut-Adige et des conseils utiles de la rédaction. Vous pouvez vous désabonner à tout moment.',
        generalError: 'Un problème est survenu. Veuillez réessayer plus tard.',
        back: 'Retour',
        submit: count => `Envoyer la demande`,
    },
    thankyou: {
        title: 'Demande réussie',
        successText: 'La demande a été envoyée avec succès',
    },
};
//# sourceMappingURL=Enquiry.i18n.fr.js.map